<template>
  <div class="serviceway">
    <uni-popup ref="bloodsugarstate" type="bottom">
      <uni-card :is-full="true">
        <!-- <div class="handle_row">
        <div class="cancel">
          <span>取消</span>
        </div>
        <div class="confirm">
          <span>确认</span>
        </div>
      </div> -->
        <div class="delete_btn" @click="deleteDesc">
          <span>清空</span>
        </div>
        <!-- <uni-card :is-full="true"> -->
        <div class="search_wrap">
          <div
            v-for="(item, i) in arr"
            :key="i"
            :class="selectedIndex === i ? 'select_result' : 'search_result'"
            @click="selectResult(item, i)"
          >
            <span>{{ item.value }}</span>
          </div>
        </div>
        <!-- <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template> -->
        <!-- </uni-card> -->
        <!-- <picker-view
        :value="selectValue"
        @change="change"
        class="picker-view"
        :indicator-style="indicatorStyle"
      >
        <picker-view-column>
          <div class="item" v-for="(item, index) in arr" :key="index">{{
            item.value
          }}</div>
        </picker-view-column>
      </picker-view> -->
      </uni-card>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    value: {
      type: [String, Array, Object],
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  // computed: {
  //   selectValue: {
  //     get() {},
  //     set(item) {
  //       const val = this.arr[item.detail.value[0]].code
  //       this.$emit('input', val)
  //     }
  //   }
  // },
  watch: {
    visible: {
      handler(val) {
        if (
          val &&
          (this.code === 'prescrip_desc' ||
            this.code === 'body_parts' ||
            this.code === 'sample_type')
        ) {
          this.start()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      arr: [],
      indicatorStyle: 'height: 1.066667rem;',
      selectedIndex: 0,
      selectVal: '',
      selected: false
    }
  },
  methods: {
    getKeyValue,
    selectResult(item, i) {
      // this.selected = true
      this.selectedIndex = i
      this.selectVal = item.code //001
      // this.outText = item.value //口服
      this.$emit('change', this.selectVal)
      this.close()
    },
    start(item) {
      // let val = this.arr[0].code
      // this.$emit('start', val)
    },
    deleteDesc() {
      this.$emit('deleteDesc', '11')
      this.close()
    },
    open() {
      // let val = this.arr[0].code
      // this.$emit('change', val)
      this.$emit('update:visible', true)

      this.$refs.bloodsugarstate.open()
    },
    close() {
      this.$emit('update:visible', false)

      this.$refs.bloodsugarstate.close()
    }
    // change(item) {
    //   let val = this.arr[item.detail.value[0]].code
    //   this.$emit('change', val)
    //   this.close()
    // }
  },
  mounted() {
    this.arr = this.getKeyValue(this.code)
  }
}
</script>
<style lang="scss" scoped>
.search_wrap {
  height: 9.92rem;
  padding: 0.682667rem;
  overflow-y: scroll;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  .search_result,
  .select_result {
    width: auto;
    height: 1.152rem;
    border-radius: 0.085333rem;
    border: 0.021333rem solid #cecece;
    line-height: 1.152rem;
    text-align: center;
    padding: 0 0.213333rem;
    // padding: .213333rem;
    color: #888;
    font-size: 0.64rem;
    margin-left: 0.512rem;
    box-sizing: border-box;
    font-weight: 400;
    margin-left: 0.512rem;
    margin-bottom: 0.512rem;
  }
  .select_result {
    // margin-left: .512rem;
    // width: auto;
    // height: 1.152rem;
    // border-radius: .085333rem;
    border: 0.021333rem solid #0089ff;
    // line-height: 1.152rem;
    // text-align: center;
    // padding: .213333rem;
    // font-size: .64rem;
    // font-weight: 400;
    color: #0089ff;
    // box-sizing: border-box;
  }
}
.delete_btn {
  height: 1.706667rem;
  background-color: #fff;
  padding-left: 0.853333rem;
  line-height: 2.56rem;
  color: #2772ff;
}
::v-deep .picker-view {
  height: 10.666667rem;
  background: #fff;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.066667rem;
  }
}
</style>
